module.exports = __webpack_public_path__ + "static/media/Push-Preview-Frame.3e45ab21.svg";